<!--
 * @Description: 
 * @Date: 2021-06-24 16:46:30
-->
<template>
  <div></div>
</template>

<script>
export default {
  name: '',
  data() {
    return {};
  },
  methods: {},
  created() {},
  beforeDestroy() {}
};
</script>

<style scoped lang="scss"></style>
